import Carousel from 'react-bootstrap/Carousel';
import React from "react";   
            
const Caro = ({images}) => {

    //<img src={photo1} alt = "Auction Alchemy Example" /> <img src="./profilePic.jpg" />

    const imgs = images.map((img) => {
        return(
            <Carousel.Item key={img}>
                <img src={img} alt = "Example page" />
            </Carousel.Item>
        );
    })
    return (
        <Carousel slide={false}>
            {/* <Carousel.Item>
                <img src={photo1} alt = "Auction Alchemy Example" />
            </Carousel.Item>
            <Carousel.Item>
                <img src={photo2} alt = "Auction Alchemy Example" />
            </Carousel.Item>
            <Carousel.Item>
                <img src={photo3} alt = "Auction Alchemy Example" />
            </Carousel.Item> */}
            {imgs}
        </Carousel>
    );

}    

export default Caro;
            